import React, { forwardRef, useCallback } from "react";
import { useSnackbar } from "notistack";
import IconButton from "@mui/material/IconButton";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import {
  CardActionIconsContainer,
  ErrorIconContainer,
  StyledCard,
  StyledCardActions,
  StyledPaper,
  StyledRequestIdDiv,
  StyledSnackBarContent,
  StyledTypography,
  StyledTypographyBoldWhite,
  TitleContainer,
} from "components/core/snackbar/SnackBarDetailedErrorMessage.styles";
import { trimNewlinesAfterTwoSubsequentMatches } from "../../../utils/strings";

const SnackBarDetailedMessage = forwardRef<HTMLDivElement, { id: string | number; message: string; requestId: string }>(
  function Test(props, ref) {
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
      closeSnackbar(props.id);
    }, [props.id, closeSnackbar]);

    return (
      <StyledSnackBarContent ref={ref}>
        <StyledCard>
          <StyledCardActions>
            <TitleContainer>
              <ErrorIconContainer>
                <ErrorOutlineIcon color={"inherit"} />
              </ErrorIconContainer>
              <StyledTypographyBoldWhite variant="subtitle2">Error</StyledTypographyBoldWhite>
            </TitleContainer>
            <CardActionIconsContainer>
              <IconButton onClick={handleDismiss} size="large">
                <CloseIcon />
              </IconButton>
            </CardActionIconsContainer>
          </StyledCardActions>
          <StyledPaper>
            <StyledTypography gutterBottom>{trimNewlinesAfterTwoSubsequentMatches(props.message)}</StyledTypography>
            <StyledRequestIdDiv>
              <StyledTypography gutterBottom>
                When reporting this error, please be sure to include the following metadata into the report:
              </StyledTypography>
              <StyledTypography gutterBottom>
                {new URL(window.location.href).host} | {props.requestId} | v{process.env.REACT_APP_VERSION}
                {process.env.REACT_APP_REDX_API_VERSION
                  ? " (api v" + process.env.REACT_APP_REDX_API_VERSION + ")"
                  : undefined}
              </StyledTypography>
            </StyledRequestIdDiv>
          </StyledPaper>
        </StyledCard>
      </StyledSnackBarContent>
    );
  }
);

export default SnackBarDetailedMessage;
